import HeardFromAPI from '@/api/heardFrom'
import { heardFrom as mutations } from '../types/mutation-types'
import { heardFrom as actions } from '../types/action-types'

export default {
  namespaced: true,
  state: {
    loading: false,
    list: [],
    selected: null
  },
  getters: {
    loading: state => state.loading,
    list: state => state.list,
    selected: state => state.selected
  },
  mutations: {
    [mutations.HEARDFROM_REQUEST] (state) {
      state.loading = true
    },
    [mutations.HEARDFROM_SUCCESS] (state, data) {
      state.loading = false
      state.list = data.map(item => ({ id: item.id, name: item.name }))
    },
    [mutations.HEARDFROM_SELECTED] (state, data) {
      state.selected = data
    },
    [mutations.HEARDFROM_ERROR] (state) {
      state.loading = false
    }
  },
  actions: {
    [actions.HEARDFROM_GET] ({ commit }, params) {
      commit(mutations.HEARDFROM_REQUEST)
      return HeardFromAPI.get(params)
        .then(res => {
          commit(mutations.HEARDFROM_SUCCESS, res.data)
        })
        .catch(err => {
          commit(mutations.HEARDFROM_ERROR)
          return Promise.reject(err)
        })
    },
    [actions.HEARDFROM_SHOW] ({ commit }, id) {
      commit(mutations.HEARDFROM_REQUEST)
      return HeardFromAPI.show(id)
        .then(res => {
          commit(mutations.HEARDFROM_SELECTED, res.data)
        })
        .catch(err => {
          commit(mutations.HEARDFROM_ERROR)
          return Promise.reject(err)
        })
    },
    [actions.HEARDFROM_CREATE] ({ dispatch }, data) {
      return HeardFromAPI.create(data).then(() => {
        dispatch(actions.HEARDFROM_GET)
      })
    },
    [actions.HEARDFROM_UPDATE] ({ dispatch }, { id, data }) {
      return HeardFromAPI.update(id, data).then(() => {
        dispatch(actions.HEARDFROM_GET)
      })
    },
    [actions.HEARDFROM_DELETE] ({ dispatch }, id) {
      return HeardFromAPI.delete(id).then(() => {
        dispatch(actions.HEARDFROM_GET)
      })
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/heardFrom.js